import React, { useState, useEffect } from 'react';

import { AdObj, PlacementId } from '@schibsted-nmp/advertising-shared';

import { useLoadBannerAd } from '../../../hooks';

type Props = {
  placementId: PlacementId;
  targetId: string;
  children?: React.ReactNode;
  adObj: AdObj;
};
const TakeoverAdComponent = ({
  placementId,
  targetId,
  children,
  adObj
}: Props) => {
  const ref = React.useRef<HTMLDivElement>(null);
  useLoadBannerAd({ placementId, targetId, ref, adObj });

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkVisibility = () => {
      // Example: show the takeover ad when the user scrolls past 100px
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener('scroll', checkVisibility);
    return () => window.removeEventListener('scroll', checkVisibility);
  }, []);

  return (
    <div
      ref={ref}
      id={targetId}
      className={`banners__takeover-ad ${isVisible ? 'visible' : 'hidden'}`}
    >
      {isVisible && <div className="banners__takeover-content">{children}</div>}
    </div>
  );
};

export default TakeoverAdComponent;
